export const ENGINEERING_MATHEMATICS_III_QUESTIONS = [
  {
    id: 1,
    title:
      "What is the importance of Laplace transforms in engineering mathematics?",
  },
  {
    id: 2,
    title: "Explain the concept of Fourier series.",
  },
];

export const DATA_STRUCTURE_AND_ANALYSIS_QUESTIONS = [
  {
    id: 1,
    title: "What is the difference between an array and a linked list?",
  },
  {
    id: 2,
    title: "Explain the time complexity of binary search.",
  },
];

export const DATABASE_MANAGEMENT_SYSTEM_QUESTIONS = [
  {
    id: 1,
    title: "What is normalization in a database?",
  },
  {
    id: 2,
    title: "Explain the ACID properties in a database transaction.",
  },
];

export const PRINCIPLE_OF_COMMUNICATION_QUESTIONS = [
  {
    id: 1,
    title: "What is the difference between analog and digital communication?",
  },
  {
    id: 2,
    title: "Explain the concept of amplitude modulation.",
  },
];

export const PARADIGMS_AND_COMPUTER_PROGRAMMING_FUNDAMENTALS_QUESTIONS = [
  {
    id: 1,
    title: "What are the different programming paradigms?",
  },
  {
    id: 2,
    title: "Explain the concept of object-oriented programming.",
  },
];

export const ENGINEERING_MATHEMATICS_IV_QUESTIONS = [
  {
    id: 1,
    title: "What is the application of vector calculus in engineering?",
  },
  {
    id: 2,
    title: "Explain the concept of partial differential equations.",
  },
];

export const COMPUTER_NETWORK_AND_NETWORK_DESIGN_QUESTIONS = [
  {
    id: 1,
    title: "What are the differences between IPv4 and IPv6?",
  },
  {
    id: 2,
    title: "Explain the concept of subnetting in computer networks.",
  },
];

export const OPERATING_SYSTEM_QUESTIONS = [
  {
    id: 1,
    title: "What is the purpose of an operating system?",
  },
  {
    id: 2,
    title: "Explain the process scheduling in an operating system.",
  },
];

export const AUTOMATA_THEORY_QUESTIONS = [
  {
    id: 1,
    title: "What is a finite automaton?",
  },
  {
    id: 2,
    title:
      "Explain the difference between deterministic and non-deterministic automata.",
  },
];

export const COMPUTER_ORGANIZATION_AND_ARCHITECTURE_QUESTIONS = [
  {
    id: 1,
    title: "What is the difference between RISC and CISC architecture?",
  },
  {
    id: 2,
    title: "Explain the concept of pipelining in CPU design.",
  },
];

export const INTERNET_PROGRAMMING_QUESTIONS = [
  {
    id: 1,
    title: "What is the difference between HTTP and HTTPS?",
  },
  {
    id: 2,
    title: "What is React a framework or library?",
  },
];

export const COMPUTER_NETWORK_SECURITY_QUESTIONS = [
  {
    id: 1,
    title: "What is the difference between Security and Integrity?",
  },
  {
    id: 2,
    title: "What is Playfair Cipher?",
  },
];

export const ENTREPRENEURSHIP_AND_E_BUSINESS_QUESTIONS = [
  {
    id: 1,
    title: "What are the key components of a business plan?",
  },
  {
    id: 2,
    title: "Explain the role of e-commerce in modern business.",
  },
];

export const SOFTWARE_ENGINEERING_QUESTIONS = [
  {
    id: 1,
    title: "What is the software development life cycle (SDLC)?",
  },
  {
    id: 2,
    title: "Explain the concept of agile methodology.",
  },
];

export const ADVANCE_DATA_MANAGEMENT_TECHNOLOGIES_QUESTIONS = [
  {
    id: 1,
    title: "What is the significance of NoSQL databases?",
  },
  {
    id: 2,
    title: "Explain the concept of big data and its management.",
  },
];

export const DATA_MINING_AND_BUSINESS_INTELLIGENCE_QUESTIONS = [
  {
    id: 1,
    title: "What is data mining and how is it used in business?",
  },
  {
    id: 2,
    title: "Explain the concept of business intelligence (BI).",
  },
];

export const WEB_X_QUESTIONS = [
  {
    id: 1,
    title: "What is Web 3.0 and how does it differ from Web 2.0?",
  },
  {
    id: 2,
    title: "Explain the concept of decentralized applications (DApps).",
  },
];

export const WIRELESS_TECHNOLOGY_QUESTIONS = [
  {
    id: 1,
    title:
      "What are the different types of wireless communication technologies?",
  },
  {
    id: 2,
    title: "Explain the concept of 5G technology and its benefits.",
  },
];

export const AI_AND_DS_I_QUESTIONS = [
  {
    id: 1,
    title: "What is artificial intelligence and how is it applied?",
  },
  {
    id: 2,
    title: "Explain the concept of machine learning in AI.",
  },
];

export const SOFTWARE_ARCHITECTURE_QUESTIONS = [
  {
    id: 1,
    title: "What is software architecture and why is it important?",
  },
  {
    id: 2,
    title: "Explain the different types of software architecture patterns.",
  },
];

export const AI_AND_DS_II_QUESTIONS = [
  {
    id: 1,
    title:
      "What is deep learning and how does it differ from machine learning?",
  },
  {
    id: 2,
    title: "Explain the concept of neural networks in AI.",
  },
];

export const INTERNET_OF_EVERYTHING_I_QUESTIONS = [
  {
    id: 1,
    title: "What is the Internet of Everything (IoE)?",
  },
  {
    id: 2,
    title: "Explain the role of IoE in smart cities.",
  },
];

export const INFRASTRUCTURE_SECURITY_QUESTIONS = [
  {
    id: 1,
    title: "What is infrastructure security and why is it important?",
  },
  {
    id: 2,
    title: "Explain the concept of intrusion detection systems (IDS).",
  },
];

export const AR_VR_QUESTIONS = [
  {
    id: 1,
    title:
      "What is the difference between augmented reality (AR) and virtual reality (VR)?",
  },
  {
    id: 2,
    title: "Explain the applications of AR and VR in various industries.",
  },
];

export const CYBER_SECURITY_AND_LAWS_QUESTIONS = [
  {
    id: 1,
    title: "What is cyber security and why is it crucial?",
  },
  {
    id: 2,
    title: "Explain the importance of cyber laws in protecting digital assets.",
  },
];

export const BIG_DATA_ANALYTICS_QUESTIONS = [
  {
    id: 1,
    title: "What is big data analytics and how is it used?",
  },
  {
    id: 2,
    title: "Explain the challenges in big data analytics.",
  },
];

export const INTERNET_OF_EVERYTHING_II_QUESTIONS = [
  {
    id: 1,
    title: "What are the key components of the Internet of Everything (IoE)?",
  },
  {
    id: 2,
    title: "Explain the impact of IoE on industries.",
  },
];

export const USER_INTERACTION_DESIGN_QUESTIONS = [
  {
    id: 1,
    title: "What is user interaction design and why is it important?",
  },
  {
    id: 2,
    title: "Explain the principles of good user interaction design.",
  },
];

export const IPR_AND_PATENTING_QUESTIONS = [
  {
    id: 1,
    title: "What is intellectual property rights (IPR)?",
  },
  {
    id: 2,
    title: "Explain the process of patenting an invention.",
  },
];
